import React from 'react'
import { useTranslation } from 'react-i18next';

const base_url = process.env.REACT_APP_BASE_URL;

const PaymentSuccess = () => {
    const { t } = useTranslation();
    const searchParams = new URLSearchParams(window.location.search);
    const amount = searchParams.get('amount');

    return (
        <div className='payment-success'>
            <img src={`${base_url}/images/accept.png`} alt=""/>
            <h1>{t("accomodation.PaymentSuccess")}</h1>
            <p>{t("accomodation.showPAID")} MYR {amount}</p>
        </div>
    );
}

export default PaymentSuccess